import { Component } from "react";
import { connect } from "react-redux";
import "./Footer.css";
const CHROME_HEADER_TOLERANCE = 5; //On ajoute une tolérance de 5 pixels au cas où
//Google change la taille de son entête par exemple

class FooterFixedOnScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            greatestDeviceSide: Math.max(window.screen.availHeight, window.screen.availWidth),
            smallestDeviceSide: Math.min(window.screen.availHeight, window.screen.availWidth),
            lostHeight: window.screen.availHeight - window.innerHeight + CHROME_HEADER_TOLERANCE, //Correspond à la place "perdue" par l'entête chrome
            currentOrientation: (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation,
        };
    }

    updateDimensions() {
        let displayFooter = true;
        let originalHeight;

        var orientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;

        if (orientation === "portrait-secondary" || orientation === "portrait-primary") {
            originalHeight = this.state.greatestDeviceSide;
        } else {
            originalHeight = this.state.smallestDeviceSide;
        }

        //Si la hauteur du contenu de MyOpen est inférieure à la hauteur de l'écran moins (grossièrement) l'entête chrome
        //Cela signifie probablement que le clavier est actif
        //On souhaite dans ce cas cacher le pied de page pour une meilleure visibilité
        if (window.innerHeight < originalHeight - this.state.lostHeight) {
            displayFooter = false;
        }

        if (this.state.displayFooter !== displayFooter) {
            this.setState({
                displayFooter,
            });
        }
    }

    updateOrientation() {
        var orientation = (screen.orientation || {}).type || screen.mozOrientation || screen.msOrientation;
        if (this.state.currentOrientation === orientation) return;

        this.setState({
            currentOrientation: orientation,
        });

        this.updateDimensions();
    }

    componentDidMount() {
        window.onresize = this.updateDimensions.bind(this);
        window.ondeviceorientation = this.updateOrientation.bind(this);
        this.updateDimensions();
    }

    componentWillUnmount() {
        window.onresize = null;
        window.ondeviceorientation = null;
    }

    render() {
        if (!this.state.displayFooter) return <div></div>;

        return (
            <div
                className={
                    "footer footer-fixed-on-screen" + (!this.props.transparentFooter ? " footer-with-background" : "")
                }
            >
                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        transparentFooter: state.layout.transparentFooter,
    };
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(FooterFixedOnScreen);
